/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.services {
    export class ExtensibilityService extends services.DataService<Wars.Domain.Model.ExtensibleContract> {

        constructor(injectedBreeze: typeof breeze, $q: angular.IQService) {
            super(injectedBreeze, $q);
        }

        public getCustomActionContract(): ng.IPromise<Wars.Domain.Model.ExtensibleContract>  {
            const query = this.breezeModule.EntityQuery
                .from("ExtensibleContracts")
                .where("interfaceName", "==", "ICustomAction")
                .expand("extensibleComponents");

            return (this.fetch(query)) as any;
        }

        public getCustomTransformers(): ng.IPromise<Wars.Domain.Model.ExtensibleContract> {
            const query = this.breezeModule.EntityQuery
                .from("ExtensibleContracts")
                .where("interfaceName", "==", "IObjectQueryCustomTransformer")
                .expand("extensibleComponents");

            return (this.fetch(query)) as any;
        }
    }
}

warsApp.registerService('ExtensibilityService', ['breeze', '$q'])